const numberOnly = (value: string) => {
  return value
    .replace(/[^0-9,.]+/, "")
    .replace(/\.+/g, ",")
    .replace(/,(.+),/g, ",$1");
};
export default numberOnly;
